export default __webpack_public_path__ + "static/media/cartoon.d2480821.png";